const channel = {
    namespaced: true,
    state: {
        list: []
    },
    mutations: {
        updateChannelList(state, newList) {
            state.list = newList;
        },
      
    },
    actions: {
        list(context) {
            this._vm.$traveller_http.get('/traveller/restui/content/channel/list')
            .then(function(response) {
                context.commit('updateChannelList', response.data);
            })
        }
    }
}

export default channel;